import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { Badge, IconButton, Stack } from "@mui/material";
import { ComponentColors } from "./types";

interface NavigationPreviewProps {
  navBarPalette: ComponentColors["navBar"];
  badgePalette: ComponentColors["badge"];
}

const NavigationPreview = ({
  navBarPalette,
  badgePalette,
}: NavigationPreviewProps) => {
  if (!navBarPalette) return null;

  return (
    <Stack
      direction="row"
      bgcolor={navBarPalette.background}
      color={navBarPalette.foreground}
      p={1}
      alignItems="center"
      justifyContent="end"
      gap={2}
      position="relative"
    >
      <span style={{ color: navBarPalette.foreground }}>Navigation</span>

      <Badge
        badgeContent={3}
        sx={{
          "& .MuiBadge-badge": {
            backgroundColor: badgePalette.background,
            color: badgePalette.foreground,
          },
        }}
      >
        <IconButton
          sx={{
            color: navBarPalette.foreground,
            "&:hover": {
              backgroundColor: "rgba(255, 255, 255, 0.1)",
            },
          }}
        >
          <ShoppingCartIcon />
        </IconButton>
      </Badge>
    </Stack>
  );
};

export default NavigationPreview;
